import { Switch, FormControlLabel, Chip } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface BooleanFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function BooleanField({ field, value, mode, onChange, disabled, hideLabel }: BooleanFieldProps) {
  const boolVal = value === true || value === 'true' || value === 1

  if (mode === 'view') {
    return <Chip label={boolVal ? 'Yes' : 'No'} size="small" color={boolVal ? 'success' : 'default'} variant="outlined" />
  }

  if (hideLabel) {
    return <Switch checked={boolVal} onChange={(e) => onChange?.(e.target.checked)} disabled={disabled} size="small" />
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={boolVal}
          onChange={(e) => onChange?.(e.target.checked)}
          disabled={disabled}
          size="small"
        />
      }
      label={field.label}
    />
  )
}
